<template>
  <div class="flacons-en-cours" @click.stop @keydown.stop>
    <p v-if="!ligne.en_cours.length" class="fc-aucun">Aucun flacon ouvert.</p>
    <div v-for="flacon in ligne.en_cours" :key="flacon.id" class="fc-flacon" :class="'fc-' + flacon.niveau">
      <span class="fc-texte"><strong>En cours :</strong> {{ flacon.resume }}</span>
      <span class="fc-actions">
        <button type="button" class="fc-cq" :class="{ fait: flacon.cq_fait }" :aria-pressed="flacon.cq_fait ? 'true' : 'false'"
          :title="flacon.cq_fait ? 'Contrôle qualité fait' + (flacon.cq_par_nom ? ' par ' + flacon.cq_par_nom : '') : 'Marquer le contrôle qualité comme fait'"
          @click="$emit('cq', flacon)">
          <i :class="flacon.cq_fait ? 'fa fa-check-circle' : 'far fa-circle'" aria-hidden="true"></i> CQ {{ flacon.cq_fait ? 'fait' : 'à faire' }}
        </button>
        <button type="button" class="fc-terminer" :aria-label="'Terminer le flacon de ' + ligne.libelle" @click="$emit('terminer', flacon)">Terminer</button>
      </span>
    </div>
    <p v-if="ligne.prevision" class="fc-prevision">{{ ligne.prevision }}</p>
  </div>
</template>

<script>
// Flacons ouverts d'un réactif (04/10/2026), sous son nom dans le tableau du stock : lot, ouverture, limite
// d'utilisation (orange à J-3, rouge dépassée), contrôle qualité, « Terminer » ; puis la couverture de la réserve.
export default {
  name: 'flacons-en-cours',
  props: { ligne: { type: Object, required: true } },
}
</script>

<style scoped>
.flacons-en-cours { margin-top: 6px; font-size: 13px; line-height: 1.45; color: var(--ui-text-secondary, #273449); }
.fc-aucun, .fc-prevision { margin: 2px 0 0; color: var(--ui-text-muted, #526074); }
.fc-flacon { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 6px 12px; margin-top: 4px;
  padding: 6px 10px; border-left: 3px solid #b8c7e6; border-radius: 8px; background: #f5f8fe; }
.fc-proche { border-left-color: #b45309; background: #fff7ed; }
.fc-proche .fc-texte { color: #8a4b08; }
.fc-depasse { border-left-color: #b42318; background: #fef3f2; }
.fc-depasse .fc-texte { color: #a01e14; font-weight: 600; }
.fc-actions { display: inline-flex; gap: 8px; }
.fc-actions button { min-height: 30px; padding: 3px 12px; border: 1px solid #c7d5f1; border-radius: 999px; background: #fff;
  color: var(--ui-accent, #2457c5); font-size: 13px; font-weight: 600; }
.fc-cq { color: var(--ui-text-secondary, #273449) !important; }
.fc-cq.fait { border-color: #a7d7bf !important; color: var(--ui-success, #166044) !important; }
.fc-actions button:hover { background: #eaf0ff; }
.fc-actions button:focus-visible { outline: 3px solid #8caaf5; outline-offset: 2px; }
</style>
